export function nameOf<T1>(key1: keyof T1): string;
export function nameOf<T1, T2>(key1: keyof T1, key2?: keyof T2): string {
  return key2 ? `${key1}.${key2}`.toLowerCase() : `${key1}`.toLowerCase();
}
